(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-related-products"] && !Shopify.designMode) return;
  try {
    (function () {
  var track = document.querySelector('.dw-related-products__scroll-track');
  var btnPrev = document.querySelector('.dw-rp-nav--prev');
  var btnNext = document.querySelector('.dw-rp-nav--next');

  if (!track || !btnPrev || !btnNext) return;

  var cardWidth = function () {
    var card = track.querySelector('.dw-rp-card');
    return card ? card.offsetWidth + 16 : 240; /* card + gap */
  };

  var scrollBy = function (dir) {
    track.scrollBy({ left: dir * cardWidth() * 2, behavior: 'smooth' });
  };

  btnPrev.addEventListener('click', function () { scrollBy(-1); });
  btnNext.addEventListener('click', function () { scrollBy(1); });

  /* Update disabled state */
  var updateNav = function () {
    btnPrev.disabled = track.scrollLeft <= 0;
    btnNext.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };

  track.addEventListener('scroll', updateNav, { passive: true });
  updateNav();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dw-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
  var bar        = document.getElementById('dw-sticky-atc');
  var mainBtn    = document.getElementById('product-add-to-cart');
  var stickyBtn  = document.getElementById('dw-sticky-btn');
  var stickyPrice = document.getElementById('dw-sticky-price');

  if (!bar || !mainBtn) return;

  // Mirror the live price display into the sticky bar
  function syncPrice() {
    var src = document.getElementById('product-price-display');
    if (src && stickyPrice) stickyPrice.textContent = src.textContent;
  }

  // Clicking sticky button clicks the real submit button in the form
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      var form = document.getElementById('add-to-cart-form');
      if (!form) return;
      var realBtn = form.querySelector('[type="submit"][name="add"]');
      if (realBtn) realBtn.click();
    });
  }

  // Show bar when the main ATC button scrolls out of view
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      var isVisible = entries[0].isIntersecting;
      bar.classList.toggle('dw-sticky-atc--visible', !isVisible);
      bar.setAttribute('aria-hidden', isVisible ? 'true' : 'false');
      if (!isVisible) syncPrice();
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    obs.observe(mainBtn);
  }

  // Sync price whenever a custom option changes
  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList.contains('custom-option-select')) {
      setTimeout(syncPrice, 80);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
